





















































import { Vue, Component, Watch } from 'vue-property-decorator'
import Search from './component/Search.vue'
import List from './component/List.vue'
import { Picker, Popup, Spinner, Loadmore } from 'mint-ui'
import Detail from './Detail.vue'
import { customerListA, CustomerD, getHuashuA, HuashuD } from '@/server/phpApi'
import { constants, connect } from 'http2';

@Component({
  components: {
    Search,
    List,
    Popup,
    Picker,
    Spinner,
    Detail,
    Loadmore,
  },
})
export default class Customers extends Vue {
  date: any = [
    {
      values: [
        { name: '请选择', value: ''},
        { name: '今天', value: 1},
        { name: '昨天', value: 2},
        { name: '最近三天', value: 3},
        { name: '最近一周', value: 4},
      ],
      textAlign: 'center',
      flex: 1,
    },
  ]

  huashuDict: HuashuD[] = []

  huashu: any = [
    {
      values: [],
      textAlign: 'center',
      flex: 1,
    },
  ]

  get grade() {
    const huashuDict = this.huashuDict.slice()
    const gradeVal = []
    for (let i = 0, l = huashuDict.length; i < l; i++) {
      if (this.screening.scene_id === huashuDict[i].id || this.screening.scene_id === '0') {
        const levels = huashuDict[i].levels.map(item => ({
          value: item.score_min + ','+ item.score_max,
          name: item.levelname,
        }))
        gradeVal.push(...levels)
      }
    }
    gradeVal.unshift({
      value: '',
      name: '请选择',
    })
    return [
      {
        values: gradeVal,
        textAlign: 'center',
        flex: 1,
      },
    ]
    
  }

  propShow: number = 0

  // 筛选条件
  screening = {
    scene_id: '',
    score_max: '',
    score_min: ''
  }

  pageInfo: any = {
    page: 1,
    pageSize: 9,
  }

  dataList: CustomerD[] = []

  isLoadingMore: boolean = false

  isBottomAllLoaded: boolean = false

  search: string = ''

  dateNode: any = ''
  huashuNode: any = ''
  gradeNode: any = ''

  topStatus: string = ''
  bottomStatus: string = ''
  translate: any = 0
  moveTranslate: any = 0

  handleSearchInput(keyword: string) {
    this.search = keyword
  }
  handleSearch() {
    this.dateNode.setSlotValue(0, '')
    this.huashuNode.setSlotValue(0, '')
    this.gradeNode.setSlotValue(0, '')
    this.screening = {
      scene_id: '',
      score_max: '',
      score_min: '',
    }
    this.loadTop()
  }
  handleCancelSearch() {
    if (this.search === '') {
      return
    }
    this.search = ''
  }
  handleConfirm() {
    this.search = ''
    this.screening = {
      scene_id: this.huashuNode.getValues()[0].value,
      score_min: this.gradeNode.getValues()[0].value.split(',')[0],
      score_max: this.gradeNode.getValues()[0].value.split(',')[1]
    }
    this.loadTop()
    this.popupClose()
  }
  // 关闭弹出
  popupClose() {
    this.propShow = 0
  }
  popupInput(val: boolean) {
    if (!val) this.popupClose()
  }
  handleReset() {
    this.dateNode.setSlotValue(0, '')
    this.huashuNode.setSlotValue(0, '')
    this.gradeNode.setSlotValue(0, '')
    this.search = ''
    this.screening = {
      scene_id: '',
      score_max: '',
      score_min: ''
    }
    this.loadTop()
  }
  loadMore() {
    this.isLoadingMore = true
    this.getDataList()
  }
  // 获得数据列表
  getDataList() {
    customerListA({
      ...this.pageInfo,
      ...this.screening,
      search: this.search,
    }).then(res => {
      if (res.errcode === 0) {
        if (res.data.data.length === 0) {
          this.isBottomAllLoaded = true
          return
        }
        this.isBottomAllLoaded = false
        this.dataList = this.dataList.concat(res.data.data)
        const loadmoreNode: any = this.$refs.loadmore
        loadmoreNode.onBottomLoaded()
        loadmoreNode.onTopLoaded()
        this.pageInfo.page = this.pageInfo.page + 1
      }
      this.isLoadingMore = false
    }).catch(() => {
      this.isLoadingMore = false
    })
  }
  loadTop() {
    this.pageInfo.page = 1
    this.dataList = []
    this.getDataList()
  }
  handleTopChange(status: any) {
    this.topStatus = status
  }
  translateChange(translate: any) {
    const translateNum = +translate
    this.translate = translateNum.toFixed(2)
    this.moveTranslate = (1 + translateNum / 70).toFixed(2)
  }
  bottomMethod() {
    this.getDataList()
  }
  handleBottomChange(status: any) {
    this.bottomStatus = status
  }
  // 获取筛选数据(话术列表和等级列表)
  getSelectList() {
    getHuashuA().then(res => {
      if (res.errcode !== 0) return
      this.huashuDict = res.data
      this.huashu[0].values = res.data.map(huashu => ({
        value: huashu.id,
        name: huashu.title,
      }))
      this.huashu[0].values.unshift({
        value: '',
        name: '请选择',
      })
    })
  }

  created() {
    this.getDataList()
    this.getSelectList()
  }

  mounted() {
    this.dateNode = this.$refs.date
    this.huashuNode = this.$refs.huashu
    this.gradeNode = this.$refs.grade
  }
}
